<form (ngSubmit)="onSubmit()" [formGroup]="directDeliveryForm">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">
      @if (createMode) {
        <span>{{ "uigCheckout.directDelivery.titleCreate" | cxTranslate }}</span>
      }
      @if (!createMode) {
        <span>{{ "uigCheckout.directDelivery.titleUpdate" | cxTranslate }}</span>
      }
    </h4>
    <button
      type="button"
      class="close"
      aria-describedby="modal-title"
      (click)="modal.dismiss('Cross click')"
      >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        <label>
          <span class="label-content">
            {{ "uigCheckout.directDelivery.fullName.label" | cxTranslate }}
          </span>
          <input
            type="text"
            class="form-control"
            name="fullName"
            maxlength="35"
            placeholder="{{
              'uigCheckout.directDelivery.fullName.placeholder' | cxTranslate
            }}"
            formControlName="fullName"
            />
            <cx-form-errors
              [control]="directDeliveryForm.get('fullName')"
            ></cx-form-errors>
          </label>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <label>
            <span class="label-content">
              {{ "uigCheckout.directDelivery.nameSuffix.label" | cxTranslate }}
            </span>
            <input
              type="text"
              class="form-control"
              name="nameSuffix"
              maxlength="35"
            placeholder="{{
              'uigCheckout.directDelivery.nameSuffix.placeholder' | cxTranslate
            }}"
              formControlName="nameSuffix"
              />
              <cx-form-errors
                [control]="directDeliveryForm.get('nameSuffix')"
              ></cx-form-errors>
            </label>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-12">
            <label>
              <span class="label-content">
                {{ "uigCheckout.directDelivery.street.label" | cxTranslate }}
              </span>
              <input
                type="text"
                class="form-control"
                name="street"
                maxlength="35"
            placeholder="{{
              'uigCheckout.directDelivery.street.placeholder' | cxTranslate
            }}"
                formControlName="street"
                />
                <cx-form-errors
                  [control]="directDeliveryForm.get('street')"
                ></cx-form-errors>
              </label>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12">
              <label>
                <span class="label-content">
                {{ "uigCheckout.directDelivery.postalCode.label" | cxTranslate }}</span>
                <input
                  type="text"
                  class="form-control"
                  name="postalCode"
                  maxlength="10"
            placeholder="{{
              'uigCheckout.directDelivery.postalCode.placeholder' | cxTranslate
            }}"
                  formControlName="postalCode"
                  />
                  <cx-form-errors
                    [control]="directDeliveryForm.get('postalCode')"
                  ></cx-form-errors>
                </label>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-12">
                <label>
                  <span class="label-content">
                    {{ "uigCheckout.directDelivery.town.label" | cxTranslate }}
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    name="town"
                    maxlength="35"
            placeholder="{{
              'uigCheckout.directDelivery.town.placeholder' | cxTranslate
            }}"
                    formControlName="town"
                    />
                    <cx-form-errors
                      [control]="directDeliveryForm.get('town')"
                    ></cx-form-errors>
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-12">
                  <label>
                    <span class="label-content">
                      {{ "uigCheckout.directDelivery.email.label" | cxTranslate }}
                    </span>
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      maxlength="241"
            placeholder="{{
              'uigCheckout.directDelivery.email.placeholder' | cxTranslate
            }}"
                      formControlName="email"
                      />
                      <cx-form-errors
                        [control]="directDeliveryForm.get('email')"
                      ></cx-form-errors>
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <label>
                      <span class="label-content">
                        {{ "uigCheckout.directDelivery.phone.label" | cxTranslate }}
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        name="phone"
                        maxlength="20"
            placeholder="{{
              'uigCheckout.directDelivery.phone.placeholder' | cxTranslate
            }}"
                        formControlName="phone"
                        />
                        <cx-form-errors
                          [control]="directDeliveryForm.get('phone')"
                        ></cx-form-errors>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="modal.dismiss('cancel click')"
                    >
                    {{ "common.cancel" | cxTranslate }}
                  </button>
                  <button type="submit" class="btn btn-secondary">
                    {{ "common.submit" | cxTranslate }}
                  </button>
                </div>
              </form>
